import axios from "axios";
import Api, { BASE_URL } from "../../shared/api/api";

function headers() {
  const token = Api.token || localStorage.getItem("token");
  if (token) Api.setToken(token);
  return token ? { Authorization: `Dragonian ${token}` } : {};
}
export function mediaRequest(endpoint, data, method) {
  headers();
  return Api.request(`api/media/${endpoint}`, data, method);
}
export async function uploadDraftFile(scope, id, file, onProgress) {
  const body = new FormData(); body.append("video", file);
  try {
    const result = await axios.post(`${BASE_URL}/api/media/${scope}/drafts/${id}/file`, body, { headers: headers(), onUploadProgress: event => onProgress(event.total ? Math.round(event.loaded * 100 / event.total) : null) });
    return result.data;
  } catch (error) { throw new Error(error.response?.data?.error?.message || "The video file could not be uploaded. Your metadata draft is saved; try attaching the file again."); }
}
export async function downloadDraftFile(scope, draft) {
  const response = await axios.get(`${BASE_URL}/api/media/${scope}/drafts/${draft.id}/file`, { headers: headers(), responseType: "blob" });
  const url = URL.createObjectURL(response.data);
  const link = document.createElement("a");
  link.href = url; link.download = draft.file_name || "video.mp4";
  document.body.appendChild(link); link.click(); link.remove();
  setTimeout(() => URL.revokeObjectURL(url), 1000);
}
export async function uploadDraftThumbnail(scope, id, file) {
  const body = new FormData(); body.append("thumbnail", file);
  try { return (await axios.post(`${BASE_URL}/api/media/${scope}/drafts/${id}/thumbnail`, body, { headers: headers() })).data; }
  catch (error) { throw new Error(error.response?.data?.error?.message || "The thumbnail could not be uploaded. Your draft is saved; try attaching it again."); }
}
export async function draftThumbnailBlob(scope, id) {
  return (await axios.get(`${BASE_URL}/api/media/${scope}/drafts/${id}/thumbnail`, { headers: headers(), responseType: "blob" })).data;
}
